import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { NgxPermissionsService } from 'ngx-permissions';
import { AuthenticationService } from './authentication.service';
import * as dayjs from 'dayjs';
import { LocalStorageService } from '@core/local-storage/local-storage.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(private router: Router, private authenticationService: AuthenticationService,
    private permissionsService: NgxPermissionsService, private localStorageService: LocalStorageService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.authenticationService.isLoggedIn
      .pipe(
        take(1),
        map((isLoggedIn: boolean) => {
          if (!isLoggedIn) {
            this.router.navigate(['/login']);
            return false;
          }

          if (!this.localStorageService.getItem('sessaoAtiva')) {
            this.authenticationService.logout();
          }

          if (this.authenticationService.currentUserValue) {
            const dataAtual = dayjs().format();
            const dataExpiracaoAcesso = dayjs(this.authenticationService.currentUserValue.expires_in).format();

            if (this.authenticationService.currentUserValue && dataAtual > dataExpiracaoAcesso) {
              this.authenticationService.logout();
              return false;
            }
          }

          return true//can;
        })
      );
  }
}
